/* eslint-disable max-len */
import { serviceName } from '../resources/serviceConstants';
import {
  BE_EFFORT,
  BE_EFFORT_WITH_BULK_EDIT,
  BASE_EFFORT,
  TECHNICAL_COMPLEXITY_EFFORT,
  REQUIREMENT_CLARITY_EFFORT,
  EXTERNAL_INTEGRATION_EFFORT,
  CALCULATE_BASE_EFFORT,
  GET_SKILLSET,
  FE_EFFORT,
  FE_EFFORT_WITH_BULK_EDIT,
  CALCULATE_FE_BASE_EFFORT,
  EFFORT_SUMMARY,
  EFFORT_SUMMARY_SUBMIT,
} from '../resources/endPoint';

export const getCalculatedBaseEffort = (backid, reqid, tecid, intid) => {
  return {
    url: `${CALCULATE_BASE_EFFORT}?backendEffortId=${backid}&requirementClarityId=${reqid}&technicalComplexityId=${tecid}&externalIntegrationId=${intid}`,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const getBEeffortDetails = (id) => {
  return {
    url: BE_EFFORT + '?deal_id=' + id,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const saveBEeffortDetails = (data) => {
  return {
    url: BE_EFFORT,
    method: 'post',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const editBEeffortDetails = (data) => {
  return {
    url: BE_EFFORT,
    method: 'put',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const editBulkBEeffortDetails = (data) => {
  return {
    url: BE_EFFORT_WITH_BULK_EDIT,
    method: 'put',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const getBEeffort = (type, active) => {
  return getBaseEffortByType(type, active);
};

const getBaseEffortByType = (type, active) => {
  return {
    url: `${BASE_EFFORT}?type=${type}&is_active=${active}`,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const getRequirementClarity = (type, active) => {
  return {
    url: `${REQUIREMENT_CLARITY_EFFORT}?type=${type}&is_active=${active}`,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};
export const getTechnicalComplexity = (type, active) => {
  return {
    url: `${TECHNICAL_COMPLEXITY_EFFORT}?type=${type}&is_active=${active}`,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};
export const getExternalIntegration = (type, active) => {
  return {
    url: `${EXTERNAL_INTEGRATION_EFFORT}?type=${type}&is_active=${active}`,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const getSkillsetData = (dealId) => {
  return {
    url: `${GET_SKILLSET}?deal_id=${dealId}`,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const putSkillsetData = (skillsetScopeId, data) => {
  return {
    url: `${GET_SKILLSET}/${skillsetScopeId}`,
    method: 'put',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const deleteSkillsetData = (skillsetId) => {
  const url = `${GET_SKILLSET}/${skillsetId}`;
  return {
    url: url,
    method: 'delete',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const saveFEeffortDetails = (data) => {
  return {
    url: FE_EFFORT,
    method: 'post',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const getBaseEffort = (type, active) => {
  return getBaseEffortByType(type, active);
};

export const getFEeffortDetails = (id) => {
  return {
    url: FE_EFFORT + '?deal_id=' + id,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const editFEeffortDetails = (data) => {
  return {
    url: FE_EFFORT,
    method: 'put',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const editBulkFEeffortDetails = (data) => {
  return {
    url: FE_EFFORT_WITH_BULK_EDIT,
    method: 'put',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const getCalculatedFeBaseEffort = (feid, reqid, tecid, intid) => {
  return {
    url: `${CALCULATE_FE_BASE_EFFORT}?feEffortId=${feid}&requirementClarityId=${reqid}&technicalComplexityId=${tecid}&externalIntegrationId=${intid}`,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const patchOtherEffort = (id, payload) => {
  return {
    url: `/v1/deal_other_efforts/${id}`,
    method: 'patch',
    headers: { 'content-type': 'application/json' },
    payload: payload,
    authRequired: false,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const getSummary = (id) => {
  return {
    url: EFFORT_SUMMARY + '?dealId=' + id,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const submitEfforts = (id, userId) => {
  return {
    url: EFFORT_SUMMARY_SUBMIT + `/${id}/?userId=${userId}`,
    method: 'patch',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};
